import keys from 'lodash/keys';

export default {
  computed: {
    paginationFiltered() {
      let items = this.pagination.data || [];
      items.forEach(item => {
        if(item.extraData) {
          item.extraData.forEach(itemExtra => {
            if(itemExtra.eExtraField)
              item[this.getExtraFieldPath(itemExtra.eExtraField.path, itemExtra.eExtraField.groupId)] = itemExtra.value;
          });
        }
      });
      return items;
    }
  },
	methods: {
    getExtraFieldPath(path, groupId) {
      let pieces = path.split('.');
      return `${pieces[0]}_${groupId}.${pieces[1]}`;
    },
    getPagination(options = null, where = null) {
      let localWhere = [...(where || [])];
      options = options || this.options
      if (!keys(options).length) return
      const criteria = this.$route.params.criteria ? { where: [this.$route.params.criteria.value] } : null;
      if (criteria && criteria.where) localWhere = [...localWhere, ...(criteria.where)];
      const hiddenCriteria = this.$route.params.hiddenCriteria ? { where: [this.$route.params.hiddenCriteria] } : null;
      if (hiddenCriteria && hiddenCriteria.where) localWhere = [...localWhere, ...(hiddenCriteria.where)];
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: options.sortBy[0],
          desc: options.sortDesc[0],
          where: [...new Set(localWhere)],
        }
      }
    }
  }
}
